import type { PurchaseLineDTO } from "../api/documents";

/** Recognize NP coming from BC, including imported KSeF invoice lines. */
export function isSettlementDimensionLine(line: PurchaseLineDTO): boolean {
  const rate = String(line.vatPercent ?? "").trim().toUpperCase().replace(/\.$/, "");
  const postingGroup = String(line.vatProdPostingGroup ?? "")
    .trim().toUpperCase().replace(/\.$/, "");

  return line.settlementType === "Charge" ||
    line.settlementType === "Deduction" ||
    rate === "NP" ||
    postingGroup === "NP" ||
    postingGroup === "VAT NP";
}

/** The exemption is enabled only by globalSetup; 0% is NOT NP. */
export function isOptionalSettlementLine(
  line: PurchaseLineDTO,
  settlementDimensionsOptional: boolean
): boolean {
  return settlementDimensionsOptional && isSettlementDimensionLine(line);
}

export function isOptionalSettlementMpkRow(
  purchaseLineNo: number | undefined,
  purchaseLines: PurchaseLineDTO[],
  settlementDimensionsOptional: boolean
): boolean {
  return purchaseLines.some((line) =>
    line.lineNo === purchaseLineNo &&
    isOptionalSettlementLine(line, settlementDimensionsOptional)
  );
}

export function getMpkExpectedNetAmount(
  documentNet: number,
  purchaseLines: PurchaseLineDTO[],
  settlementDimensionsOptional: boolean
): number {
  if (!settlementDimensionsOptional) return documentNet;
  const optionalAmount = purchaseLines.reduce(
    (total, line) => total + (
      isOptionalSettlementLine(line, true) ? Number(line.amount || 0) : 0
    ),
    0
  );
  return Number((documentNet - optionalAmount).toFixed(2));
}

export function hasRequiredPurchaseLineAmounts(
  purchaseLines: PurchaseLineDTO[],
  settlementDimensionsOptional: boolean
): boolean {
  return purchaseLines.some((line) =>
    !isOptionalSettlementLine(line, settlementDimensionsOptional) &&
    Math.abs(Number(line.amount || 0)) > 0.01
  );
}
